/** @flow */

export const integrationsMessages = {
  en: {
    INTEGRATION_APPLICATION_CREATED: "Application was registered successfully",
    INTEGRATION_APPLICATION_UPDATED: "Application was updated successfully",
    INTEGRATION_APPLICATION_DELETED: "Application was deleted successfully",
    INTEGRATION_SECRET_COPIED: "Client secret was copied to the clipboard",
    INTEGRATION_OFFLINE_TOKEN_COPIED: "Offline token was copied to the clipboard",
  },
};

export default {
  en: {
    INTEGRATIONS: "Integrations",
    INTEGRATION_APPLICATIONS_INFO:
      "When registering an application, you will need to confirm the application name and provide a brief description. You will also need to confirm the environment you wish the Application to point to. STAGE is a testing environment where you can safely Get, Post, Put and Delete data without disrupting live services. PROD is the live environment where any changes will take immediate effect.",
    RESOURCES: "Resources",
    INTEGRATION_RESOURCES_INFO:
      "Listed below are Human Resource, Payroll and Rostering Software applications that clients commonly integrate with GoodShape. If you use any of the software listed below, clicking on the tile will navigate you to their rest API and integration documentation.",
    INTEGRATION_DOCUMENTATION_INFO:
      "Provided below is documentation to support you with integrations, including information on versioning, schemas, authentication, access tokens, network security, pagination, searching, sorting and HTTPs codes.",
    APPLICATIONS: "Applications",
    DOCUMENTATION: "Documentation",
    APIS: "APIs",
    APPLICATION_NAME: "Application Name",
    ENVIRONMENT: "Environment",
    BASE_URL: "Base URL",
    NO_APPLICATIONS_REGISTERED: "No applications have been registered yet",
    REGISTER_NEW_APPLICATION: "Register New Application",
    EDIT_APPLICATION: "Edit Application",
    DELETE_APPLICATION: "Delete Application",
    DELETE_APPLICATION_QUESTION: 'Are you sure you want to delete the application "{name}"?',
    TOKEN: "Token",
    NOTIFIED_EMAILS_LABEL: "Email Addresses for Notifications and Error Reports",
    NOTIFIED_EMAILS_NOTE:
      "Error alerts will be sent to these email addresses. These alerts will not contain sensitive information but may sometimes include unique employee or absence IDs. Please ensure that only appropriate email addresses are entered. GoodShape takes no responsibility for any onward actions you take with these emails. NOTE: Email alerts are only sent for the LIVE environment.",
    ADD_EMAIL: "Add Email",
    STAGE_TEST_ENVIRONMENT: "Stage (Test Environment)",
    PROD: "Prod",
    STAGE_ENVIRONMENT: "Stage Environment",
    PROD_ENVIRONMENT: "Prod Environment",
    GET_AUTHENTICATION_TOKEN: "Get Authentication Token",
    CLIENT_SECRET: "Client Secret",
    OFFLINE_TOKEN: "Offline Token",
    REVEAL: "Reveal",
    NEW_KEY: "New Key",
    NEW_TOKEN: "New Token",
    ABSENCE_RECORDS: "Absence Records",
    HIERARCHY_STRUCTURE: "Hierarchy Structure",
    REFERENCE_LISTS: "Reference Lists",
    MASTER_DATA: "Master Data",
    INTEGRATION_INVALID_OFFLINE_TOKEN: "Invalid offline token. Please generate a new token.",
    INTEGRATION_INVALID_CLIENT: "{description}. Please generate a new client secret key.",
    INTEGRATION_TOKEN_EXCHANGE_FAILED:
      "Please generate a new client secret key and a new offline token.",
  },
};
